import { Badge, Tooltip, Input } from "antd";
import React from "react";
import {
  NewRefreshIcon,
  NewFilterIcon,
  NewSearchIcon,
  NewUploadIcon,
  NewAddIcon,
} from "../icons/ApplicationColor";
import { useNavigate } from "react-router-dom";
const CommonTopDetails = ({
  title,
  titleSuffix,
  showModal,
  searchPlaceholder = "Search...",
  filterUrl,
  filterAction,
  resetFilterAction,
  searchAction,
  showAddButton,
  showUploadButton,
  addButtonProps = {},
  filterButtonProps = {},
  resetButtonProps = {},
  uploadButtonProps = {},
  customContent = <></>,
  marginPass = "70px",
  showSearch = true,
  searchValue = "",
  topSizeAdd = "0px",
  paddingInlinepass = "20px",
  sorting = false,
  variantPass = "md",
  ...otherPops
}) => {
  const navigate = useNavigate();

  const handleAddButtonClick = () => {
    if (
      addButtonProps?.modalType === "Redirect" &&
      addButtonProps?.redirctlink
    ) {
      navigate(addButtonProps.redirctlink);
    } else if (
      addButtonProps?.modalType === "PopUP" &&
      addButtonProps?.modalProps
    ) {
      addButtonProps.modalProps();
    }
  };
  const handleUploadButtonClick = () => {
    if (
      uploadButtonProps?.modalType === "Redirect" &&
      uploadButtonProps?.redirctlink
    ) {
      navigate(uploadButtonProps.redirctlink);
    } else if (
      uploadButtonProps?.modalType === "PopUP" &&
      uploadButtonProps?.modalProps
    ) {
      uploadButtonProps.modalProps();
    }
  };
  const handleFilterButtonClick = () => {
    if (
      filterButtonProps?.modalType === "Redirect" &&
      filterButtonProps?.redirctlink
    ) {
      navigate(filterButtonProps.redirctlink);
    } else if (
      filterButtonProps?.modalType === "PopUP" &&
      filterButtonProps?.modalProps
    ) {
      filterButtonProps.modalProps();
    }
    console.log("click", filterButtonProps);
  };
  const handleResetClick = () => {
    if (resetButtonProps?.modalProps) {
      resetButtonProps.modalProps();
    }
  };
  return (
    <div
      style={{
        marginTop: marginPass,
        paddingInline: paddingInlinepass,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "15px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "baseline",
          paddingLeft: "5px",
        }}
      >
        <span
          style={{
            color: "#3F3F3F",
            fontSize: variantPass === "md" ? "16.5px" : "14.5px",
            fontWeight: "500",
          }}
        >
          {title}
        </span>
        <span
          style={{
            color: "#7993AF",
            fontSize: "16.5px",
            margin: "0 5px",
          }}
        >
          |
        </span>
        <span
          style={{
            color: "#7993AF",
            fontSize: "12px",
            fontWeight: "400",
          }}
        >
          {titleSuffix}
        </span>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {customContent}
        {filterAction && (
          <>
            <Tooltip title={sorting ? "Reset Filters" : "Reset Filters"}>
              <div style={{ cursor: "pointer" }} onClick={handleResetClick}>
                <NewRefreshIcon />
              </div>
            </Tooltip>

            <Tooltip title="Apply Filters">
              <Badge dot={filterUrl}>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={handleFilterButtonClick}
                >
                  <NewFilterIcon />
                </div>
              </Badge>
            </Tooltip>
          </>
        )}
        {showSearch &&
          (searchValue ? (
            <Input
              value={searchValue}
              suffix={<NewSearchIcon />}
              style={{
                borderRadius: "5px",
                padding: variantPass === "md" ? "5px 10px" : "3px 7px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
              allowClear
              placeholder={searchPlaceholder}
              onChange={searchAction}
              onPressEnter={searchAction}
            />
          ) : (
            <Input
              suffix={<NewSearchIcon />}
              style={{
                borderRadius: "5px",
                padding: variantPass === "md" ? "5px 10px" : "3px 7px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
              allowClear
              placeholder={searchPlaceholder}
              onChange={searchAction}
              onPressEnter={searchAction}
            />
          ))}

        {showUploadButton && (
          <Tooltip title={uploadButtonProps?.disabled ? "" : "Upload"}>
            <div
              style={{
                cursor: uploadButtonProps?.disabled ? "not-allowed" : "pointer",
                marginTop: topSizeAdd,
                opacity: uploadButtonProps?.disabled ? 0.5 : 1,
              }}
              onClick={() =>
                !uploadButtonProps?.disabled && handleUploadButtonClick()
              }
            >
              <NewUploadIcon />
            </div>
          </Tooltip>
        )}

        {showAddButton && (
          <Tooltip title={addButtonProps?.disabled ? "" : "Add New"} placement="left">
            <div
              style={{
                cursor: addButtonProps?.disabled ? "not-allowed" : "pointer",
                marginTop: topSizeAdd,
                opacity: addButtonProps?.disabled ? 0.5 : 1,
              }}
              onClick={() => !addButtonProps?.disabled && handleAddButtonClick()}
            >
              <NewAddIcon />
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default CommonTopDetails;
